import { render, staticRenderFns } from "./ProjectsList.vue?vue&type=template&id=1deedb3b&scoped=true"
import script from "./projectsList.ts?vue&type=script&lang=ts&external"
export * from "./projectsList.ts?vue&type=script&lang=ts&external"
import style0 from "./ProjectsList.vue?vue&type=style&index=0&id=1deedb3b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deedb3b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1deedb3b')) {
      api.createRecord('1deedb3b', component.options)
    } else {
      api.reload('1deedb3b', component.options)
    }
    module.hot.accept("./ProjectsList.vue?vue&type=template&id=1deedb3b&scoped=true", function () {
      api.rerender('1deedb3b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/manager/projects/projects-list/ProjectsList.vue"
export default component.exports